module.exports = __webpack_public_path__ + "img/k.48f69cca.jpg";